import script from "./RatingTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingTable.vue?vue&type=script&setup=true&lang=js"

import "./RatingTable.vue?vue&type=style&index=0&id=5144ccc2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5144ccc2"]])

export default __exports__